"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = useInterval;
const react_1 = require("react");
/**
 * A custom hook to execute a function at a given interval
 * @param fn Function to execute at interval
 * @param interval Interval in milliseconds
 */
function useInterval(fn, interval) {
    (0, react_1.useEffect)(() => {
        const id = setInterval(fn, interval);
        return () => {
            clearInterval(id);
        };
    });
}
